import React from "react";

import { t, DIR } from "../../../i18n";
const CustomTableOfDashboard = ({ headers, data, actions }) => {
  // Mobile card view rendering
  const renderMobileCard = (row) => {
    // Define the fields to display in the mobile view
    const mobileFields = ["sequence", "name", "job", "salary", "phone"];

    return (
      <div className="data-card mb-4">
        {mobileFields.map((field, index) => {
          const value = row[field];
          return (
            <div key={index} className="data-row">
              <span className="data-row-label">{headers[index] || field}:</span>
              <span className="data-row-value">
                {value !== null && value !== undefined ? value.toString() : ""}
              </span>
            </div>
          );
        })}
        {actions && (
          <div className="data-card-actions">
            {actions
              .filter((action) => !action.hidden?.(row))
              .map((action, actionIndex) => (
                <button
                  key={actionIndex}
                  className={`${action.className}`}
                  onClick={() => action.onClick(row)}
                >
                  {action.label}
                </button>
              ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="mt-6" dir={DIR}>
      {/* Wrapper to prevent movement */}
      <div className="bg-slate-100 p-3 sm:p-4 rounded-xl" style={{ minHeight: "400px" }}>
        {/* Mobile View */}
        <div className="block lg:hidden space-y-4">
          {data.map((row, index) => (
            <div key={index}>{renderMobileCard(row)}</div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden lg:block card card-pad-sm">
          <table className="w-full border-collapse rounded-lg overflow-hidden table-fixed">
            <thead>
              <tr className="bg-brand-600 text-white text-base font-semibold">
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="p-4 text-center whitespace-normal break-words"
                    style={{ width: `${100 / headers.length}%` }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="text-center odd:bg-card even:bg-slate-50 hover:bg-brand-50 transition-colors"
                  >
                    {Object.entries(row).map(([key, value], cellIndex) =>
                      key === "id" || key.startsWith("_") ? null : (
                        <td
                          key={cellIndex}
                          className="p-4 border-b border-slate-200 text-center whitespace-normal break-words"
                          title={value}
                        >
                          {value}
                        </td>
                      )
                    )}
                    {actions && (
                      <td className="p-4 border-b border-slate-200 text-center">
                        <div className="flex flex-wrap justify-center gap-2">
                          {actions
                            .filter((action) => !action.hidden?.(row))
                            .map((action, actionIndex) => (
                              <button
                                key={actionIndex}
                                className={action.className}
                                onClick={() => action.onClick(row)}
                              >
                                {action.label}
                              </button>
                            ))}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={headers.length} className="text-center py-10 text-slate-500">
                    {t("لا توجد بيانات لعرضها")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomTableOfDashboard;
